import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import router, { constantRoutes } from '@/router';
import { defineStore } from 'pinia';
import { store } from "@/stores";
// import router from '@/router'
// const modules = import.meta.glob('../../views/**/**.vue')
// const modules = require.context('@/views', false, /\.vue$/);
// console.log('modules', modules)
// const Layout = () => import('@/layout/index.vue')

export const usePermissionStore = defineStore('permission', () => {
  // const permissionList = ref([])
  /** 所有路由，包括静态和动态路由 */
  const routes = ref([]);
  /** 混合模式左侧菜单 */
  const mixLeftMenus = ref([]);
  const isRoutesLoaded = ref(false);

  // function generateRoutes() {
  //     return new Promise((resolve, reject) => {
  //         try {
  //             let dynamicRoutes = []
  //             // const dynamicRoutes = transformRoutes(menuList);
  //             routes.value = constantRoutes.concat(dynamicRoutes);
  //             // routes.value = constantRoutes
  //             isRoutesLoaded.value = true
  //             // console.log('routes',dynamicRoutes)
  //             // resolve(dynamicRoutes)
  //             resolve(routes.value)
  //         } catch (error) {
  //             reject(error)
  //         }
  //     })
  // }

  /**
   * 重置路由
   */
  const resetRouter = () => {
    // 删除动态路由，保留静态路由
    routes.value.forEach(route => {
      if (route.name && !constantRoutes.find(r => r.name === route.name)) {
        router.removeRoute(route.name); // 从 router 实例中移除动态路由
      }
    });
    routes.value = [];
    // mixLeftMenus.value = []
    isRoutesLoaded.value = false;
  };
  return {
    routes,
    // generateRoutes,
    mixLeftMenus,
    // setMixLeftMenus,
    isRoutesLoaded,
    resetRouter
  };
});

/**
 * 转换路由数据为组件
 */
// const transformRoutes = (routes) => {
//     const asyncRoutes = []
//     routes.forEach((route) => {
//         const tmpRoute = {...route}
//         // 使用服务器接口
//         if (tmpRoute.component?.toString() == 'Layout') {
//             tmpRoute.component = Layout
//         } else {
//             // const component = modules[`../../views/${tmpRoute.component}.vue`]
//             // if (component) {
//             //     tmpRoute.component = component
//             // } else {
//             //     tmpRoute.component = modules['../../views/error/404.vue']
//             // }
//         }
//         if (tmpRoute.children) {
//             tmpRoute.children = transformRoutes(route.children)
//         }
//         asyncRoutes.push(tmpRoute)
//     })
//
//     return asyncRoutes
// }

export function usePermissionStoreHook() {
  return usePermissionStore(store);
}